module.exports = __webpack_public_path__ + "img/fh.f00898ac.svg";